import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RecruitmentDashboardComponent } from './recruitment-dashboard.component';

const routes: Routes = [
  {path: 'recruitment-dashboard', component: RecruitmentDashboardComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RecruitmentDashboardRoutingModule { }
